// src/helpers/util.js
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8080/api",
  withCredentials: false, // we are NOT using cookies
});

// Attach Authorization + X-Company-Id to every request
api.interceptors.request.use(
  (config) => {
    // ---- Access Token ----
    const tokenRaw = localStorage.getItem("tokens");
    if (tokenRaw) {
      try {
        const accessToken = JSON.parse(tokenRaw);
        if (accessToken) {
          config.headers.Authorization = `Bearer ${accessToken}`;
        }
      } catch (e) {
        console.warn("⚠️ Invalid token in localStorage, clearing it");
        localStorage.removeItem("tokens");
      }
    }

    // ---- Selected Company (tenant) ----
    const selectedCompany = localStorage.getItem("selectedCompany");
    if (selectedCompany) {
      config.headers["X-Company-Id"] = selectedCompany;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Optional: global response handler (keeps app stable)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Auto logout on auth failure
    if (error?.response?.status === 401) {
      console.warn("🔐 Unauthorized – token expired or invalid");
      // optional: clear auth & redirect to login
      // localStorage.clear();
      // window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
